(function () {
  'use strict';

  var selectors = {
    root: '[data-wellness-duo]',
    button: '[data-duo-add]',
    label: '[data-duo-label]',
    status: '[data-duo-status]'
  };

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function route(path) {
    return shopRoot() + path.replace(/^\//, '');
  }

  async function responseError(response) {
    var fallback = 'We could not add the duo. Please try again.';
    try {
      var data = await response.json();
      return data.description || data.message || data.error || fallback;
    } catch (error) {
      return fallback;
    }
  }

  async function fetchProduct(handle) {
    var response = await fetch(route('products/' + encodeURIComponent(handle) + '.js'), {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Product information could not be verified.');
    return response.json();
  }

  function availableVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (variant) {
      return variant.available;
    }) || null;
  }

  function updateCartCount(cart) {
    document.querySelectorAll('.CartCount').forEach(function (count) {
      count.textContent = cart.item_count;
    });
    var wrapper = document.getElementById('CartCount');
    if (wrapper) wrapper.classList.toggle('hide', cart.item_count === 0);
  }

  function refreshCartUI(cart) {
    updateCartCount(cart);

    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
      return;
    }

    if (window.theme && window.theme.RightDrawer && typeof window.theme.RightDrawer.open === 'function') {
      window.theme.RightDrawer.open();
    }
  }

  async function getCart() {
    var response = await fetch(route('cart.js'), {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('The cart could not be refreshed.');
    return response.json();
  }

  function init(root) {
    if (root.dataset.duoInitialized === 'true') return;

    var button = root.querySelector(selectors.button);
    var label = root.querySelector(selectors.label);
    var status = root.querySelector(selectors.status);
    var proxyButton = root.querySelector('[data-duo-proxy]');
    var referenceStatus = root.querySelector('[data-duo-reference-status]');
    var quantityInput = root.querySelector('[data-duo-quantity]');
    var quantityMinus = root.querySelector('[data-duo-quantity-minus]');
    var quantityPlus = root.querySelector('[data-duo-quantity-plus]');
    var quantitySummary = root.querySelector('[data-duo-quantity-summary]');
    if (!button || !label || !status) return;

    root.dataset.duoInitialized = 'true';
    var submitting = false;
    var quantity = quantityInput ? Math.max(1, Math.min(12, Number(quantityInput.value) || 1)) : 1;
    var products = {
      chondroitin: {
        handle: root.dataset.chondroitinHandle,
        id: Number(root.dataset.chondroitinVariant || 0),
        available: root.dataset.chondroitinAvailable === 'true'
      },
      omega: {
        handle: root.dataset.omegaHandle,
        id: Number(root.dataset.omegaVariant || 0),
        available: root.dataset.omegaAvailable === 'true'
      }
    };

    function setStatus(message, error) {
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(error));
      if (referenceStatus) referenceStatus.textContent = message || '';
    }

    function ready() {
      return products.chondroitin.id > 0 &&
        products.omega.id > 0 &&
        products.chondroitin.available &&
        products.omega.available;
    }

    function setLoading(loading) {
      submitting = loading;
      button.disabled = loading || !ready();
      if (proxyButton) proxyButton.disabled = loading || !ready();
      button.setAttribute('aria-busy', loading ? 'true' : 'false');
      label.textContent = loading ? button.dataset.loadingLabel : button.dataset.defaultLabel;
    }

    function updateQuantity(nextQuantity) {
      quantity = Math.max(1, Math.min(12, Number(nextQuantity) || 1));
      if (quantityInput) quantityInput.value = quantity;
      if (quantityMinus) quantityMinus.disabled = submitting || quantity <= 1;
      if (quantityPlus) quantityPlus.disabled = submitting || quantity >= 12;
      if (quantitySummary) quantitySummary.textContent = quantity + ' of each chew added to cart';
    }

    async function resolveProducts() {
      if (ready()) {
        button.disabled = false;
        if (proxyButton) proxyButton.disabled = false;
        return;
      }

      button.disabled = true;
      if (proxyButton) proxyButton.disabled = true;
      setStatus('Checking Duo availability…', false);

      try {
        var resolved = await Promise.all([
          fetchProduct(products.chondroitin.handle),
          fetchProduct(products.omega.handle)
        ]);
        var chondroitin = availableVariant(resolved[0]);
        var omega = availableVariant(resolved[1]);
        var chondroitinLink = root.querySelector('[data-duo-product-link="chondroitin"]');
        var omegaLink = root.querySelector('[data-duo-product-link="omega"]');

        products.chondroitin.id = chondroitin ? Number(chondroitin.id) : 0;
        products.chondroitin.available = Boolean(chondroitin);
        products.omega.id = omega ? Number(omega.id) : 0;
        products.omega.available = Boolean(omega);
        if (chondroitinLink && resolved[0].url) chondroitinLink.href = resolved[0].url;
        if (omegaLink && resolved[1].url) omegaLink.href = resolved[1].url;

        if (ready()) {
          setStatus('', false);
          button.disabled = false;
          if (proxyButton) proxyButton.disabled = false;
        } else {
          setStatus('The Duo is currently unavailable because one or both products are sold out.', true);
        }
      } catch (error) {
        setStatus('We could not verify Duo availability. Please refresh and try again.', true);
      }
    }

    button.addEventListener('click', async function () {
      if (submitting || !ready()) return;

      var succeeded = false;
      setStatus('', false);
      setLoading(true);

      try {
        var response = await fetch(route('cart/add.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              { id: products.chondroitin.id, quantity: quantity },
              { id: products.omega.id, quantity: quantity }
            ]
          })
        });

        if (!response.ok) throw new Error(await responseError(response));
        await response.json();

        var cart = await getCart();
        refreshCartUI(cart);
        succeeded = true;
        setStatus('Both products were added to your cart.', false);
      } catch (error) {
        setStatus(error.message || 'We could not add the duo. Please try again.', true);
      } finally {
        setLoading(false);
        if (succeeded) {
          label.textContent = button.dataset.successLabel;
          window.setTimeout(function () {
            label.textContent = button.dataset.defaultLabel;
          }, 2200);
        }
      }
    });

    if (proxyButton) {
      proxyButton.addEventListener('click', function () {
        if (!proxyButton.disabled && !submitting) button.click();
      });
    }

    if (quantityMinus) {
      quantityMinus.addEventListener('click', function () {
        if (!submitting) updateQuantity(quantity - 1);
      });
    }

    if (quantityPlus) {
      quantityPlus.addEventListener('click', function () {
        if (!submitting) updateQuantity(quantity + 1);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        updateQuantity(quantityInput.value);
      });
    }

    updateQuantity(quantity);
    resolveProducts();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(selectors.root).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
